import { Download } from "lucide-react";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { toast } from "@/components/ui/use-toast";
import { buildOutfit } from "../../../lib/outfit";
import { useConfigStore } from "../../../store/configStore";
import { useEditorStore } from "../../../store/editorStore";

export interface ExportOutfitMenuItemProps {
  templateConfig: any;
  selectedSkins: string[];
  selectedToningColors: Record<string, string>;
  currentAnimation: string | undefined;
  /** 路由里的模板 id，写入 outfit.data[].templateId */
  templateId: string | undefined;
}

/**
 * 导出当前搭配 JSON。buildOutfit 不区分静态/普通 Spine 模版类型，结构一致。
 */
export function ExportOutfitMenuItem({
  templateConfig,
  selectedSkins,
  selectedToningColors,
  currentAnimation,
  templateId,
}: ExportOutfitMenuItemProps) {
  const { loadedRelatedTemplates } = useConfigStore();
  const existingSpineVersion = useEditorStore((s) => s.existingSpineVersion);

  const handleExportOutfit = () => {
    if (!templateConfig) {
      toast({
        variant: "destructive",
        title: "导出失败",
        description: "没有可导出的配置",
      });
      return;
    }

    const outfit = buildOutfit(
      {
        config: templateConfig,
        id: templateId,
        spineVersion: existingSpineVersion ?? undefined,
      },
      loadedRelatedTemplates,
      selectedSkins,
      selectedToningColors,
      currentAnimation,
    );
    if (!outfit) {
      toast({
        variant: "destructive",
        title: "导出失败",
        description: "无法构建搭配数据",
      });
      return;
    }

    const jsonStr = JSON.stringify(outfit, null, 2);
    const blob = new Blob([jsonStr], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "avatar-outfit.json";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <DropdownMenuItem onClick={handleExportOutfit} disabled={!templateConfig}>
      <Download className="h-4 w-4 mr-2" />
      导出搭配
    </DropdownMenuItem>
  );
}
